import { IFieldProps } from "types/Organisational";

import Textarea from "components/atoms/Textarea/Textarea";
import Input from "components/v2/Input/Input";
import Select from "components/v2/Select/Select";
import { testIdFromFieldName } from "@RequestFormV2/utils/testIds";

type SelectOption = { label: string; value: string };

export type OrganisationDynamicFieldProps = {
  field: IFieldProps;
  getDropdownOptions: (field: IFieldProps) => SelectOption[];
  isDisabled?: boolean;
  onDropdownChange?: (value: string | null) => void;
  useInitialData?: boolean;
  unknownTypeBehavior?: "readonly" | "editable";
};

export default function OrganisationDynamicField({
  field,
  getDropdownOptions,
  isDisabled = false,
  onDropdownChange,
  useInitialData = false,
  unknownTypeBehavior = "readonly",
}: OrganisationDynamicFieldProps) {
  const { field_id, label, type, dropdown_values, mandatory, placeholder, initial_data } = field;
  const fieldName = `organizational.${field_id}`;

  switch (type) {
    case "dropdown":
      return (
        <Select
          key={field_id}
          name={fieldName}
          label={label}
          required={mandatory}
          placeholder={placeholder}
          options={getDropdownOptions(field)}
          isDisabled={isDisabled}
          isClearable
          preselect
          testId={testIdFromFieldName(fieldName, "select")}
          {...(onDropdownChange && { onChange: onDropdownChange })}
        />
      );
    case "textinput":
      return (
        <Input
          key={field_id}
          name={fieldName}
          label={label}
          required={mandatory}
          placeholder={placeholder}
          disabled={isDisabled}
          testId={testIdFromFieldName(fieldName, "input")}
          {...(useInitialData && initial_data !== undefined && { defaultValue: initial_data })}
        />
      );
    case "textarea":
      return (
        <div key={field_id} className="rfv2-two-column-grid__full-width">
          <Textarea
            name={fieldName}
            required={mandatory}
            placeholder={placeholder || `Add ${label.toLowerCase()}`}
            rows={2}
            className="bg-white"
            defaultValue={initial_data}
            testId={testIdFromFieldName(fieldName, "textarea")}
          />
        </div>
      );
    default:
      if (unknownTypeBehavior === "editable") {
        return (
          <Input
            key={field_id}
            name={fieldName}
            label={label}
            required={mandatory}
            placeholder={placeholder}
            defaultValue={initial_data}
            testId={testIdFromFieldName(fieldName, "input")}
          />
        );
      }
      return (
        <Input
          key={field_id}
          name={fieldName}
          label={label}
          required
          disabled
          defaultValue={(dropdown_values as any[])?.[0]?.value}
          testId={testIdFromFieldName(fieldName, "input")}
        />
      );
  }
}
